export const ListOfQuestions = [
  {
    id: 1,
    question:
      "In which decade was the American Institute of Electrical Engineers (AIEE) founded?",
    answers: [
      {
        text: "1850s",
        correct: false,
      },
      {
        text: "1880s",
        correct: true,
      },
      {
        text: "1930s",
        correct: false,
      },
      {
        text: "1950s",
        correct: false,
      },
    ],
  },
  {
    id: 2,
    question:
      "What is part of a database that holds only one type of information?",
    answers: [
      {
        text: "Report",
        correct: false,
      },
      {
        text: "Record",
        correct: false,
      },
      {
        text: "Field",
        correct: true,
      },
      {
        text: "File",
        correct: false,
      },
    ],
  },
  {
    id: 3,
    question: "'OS' computer abbreviation usually means ?",
    answers: [
      {
        text: "Order of Significance",
        correct: false,
      },
      {
        text: "Open Software",
        correct: false,
      },
      {
        text: "Optical Sensor",
        correct: false,
      },
      {
        text: "Operating System",
        correct: true,
      },
    ],
  },
  {
    id: 4,
    question:
      "In which decade with the first transatlantic radio broadcast occur?",
    answers: [
      {
        text: "1900s",
        correct: true,
      },
      {
        text: "1850s",
        correct: false,
      },
      {
        text: "1860s",
        correct: false,
      },
      {
        text: "1870s",
        correct: false,
      },
    ],
  },
  {
    id: 5,
    question: "'.MOV' extension refers usually to what kind of file?",
    answers: [
      {
        text: "Image file",
        correct: false,
      },
      {
        text: "Animation/movie file",
        correct: true,
      },
      {
        text: "Audio file",
        correct: false,
      },
      {
        text: "MS Office document",
        correct: false,
      },
    ],
  },
  {
    id: 6,
    question: "In which decade was the SPICE simulator introduced?",
    answers: [
      {
        text: "1950s",
        correct: false,
      },
      {
        text: "1960s",
        correct: false,
      },
      {
        text: "1970s",
        correct: true,
      },
      {
        text: "1980s",
        correct: false,
      },
    ],
  },
  {
    id: 7,
    question:
      "Most modern TV's draw power even if turned off. The circuit the power is used in does what function?",
    answers: [
      {
        text: "Sound",
        correct: false,
      },
      {
        text: "Remote control",
        correct: true,
      },
      {
        text: "Color balance",
        correct: false,
      },
      {
        text: "High voltage",
        correct: false,
      },
    ],
  },
  {
    id: 8,
    question:
      "Which is a type of Electrically-Erasable Programmable Read-Only Memory?",
    answers: [
      {
        text: "Flash",
        correct: true,
      },
      {
        text: "Flange",
        correct: false,
      },
      {
        text: "Fury",
        correct: false,
      },
      {
        text: "FRAM",
        correct: false,
      },
    ],
  },
  {
    id: 9,
    question: "The purpose of choke in tube light is ?",
    answers: [
      {
        text: "To decrease the current",
        correct: false,
      },
      {
        text: "To increase the current",
        correct: false,
      },
      {
        text: "To decrease the voltage momentarily",
        correct: false,
      },
      {
        text: "To increase the voltage momentarily",
        correct: true,
      },
    ],
  },
  {
    id: 10,
    question:
      "Who is largely responsible for breaking the German Enigma codes, created a test that provided a foundation for artificial intelligence?",
    answers: [
      {
        text: "Alan Turing",
        correct: true,
      },
      {
        text: "Jeff Bezos",
        correct: false,
      },
      {
        text: "George Boole",
        correct: false,
      },
      {
        text: "Charles Babbage",
        correct: false,
      },
    ],
  },
  {
    id: 11,
    question: "Who developed Yahoo?",
    answers: [
      {
        text: "Dennis Ritchie & Ken Thompson",
        correct: false,
      },
      {
        text: "David Filo & Jerry Yang",
        correct: true,
      },
      {
        text: "Vint Cerf & Robert Kahn",
        correct: false,
      },
      {
        text: "Steve Case & Jeff Bezos",
        correct: false,
      },
    ],
  },
  {
    id: 12,
    question:
      "Made from a variety of materials, such as carbon, which inhibits the flow of current...?",
    answers: [
      {
        text: "Choke",
        correct: false,
      },
      {
        text: "Inductor",
        correct: false,
      },
      {
        text: "Resistor",
        correct: true,
      },
      {
        text: "Capacitor",
        correct: false,
      },
    ],
  },
  {
    id: 13,
    question: "What does VVVF stand for?",
    answers: [
      {
        text: "Variant Voltage Vile Frequency",
        correct: false,
      },
      {
        text: "Variable Velocity Variable Fun",
        correct: false,
      },
      {
        text: "Very Very Vicious Frequency",
        correct: false,
      },
      {
        text: "Variable Voltage Variable Frequency",
        correct: true,
      },
    ],
  },
  {
    id: 14,
    question: "What frequency range is the High Frequency band?",
    answers: [
      {
        text: "100 kHz",
        correct: false,
      },
      {
        text: "1 GHz",
        correct: false,
      },
      {
        text: "30 to 300 MHz",
        correct: false,
      },
      {
        text: "3 to 30 MHz",
        correct: true,
      },
    ],
  },
  {
    id: 15,
    question:
      "In which year was MIDI(Musical Instrument Digital Interface) introduced?",
    answers: [
      {
        text: "1987",
        correct: false,
      },
      {
        text: "1983",
        correct: true,
      },
      {
        text: "1973",
        correct: false,
      },
      {
        text: "1977",
        correct: false,
      },
    ],
  },
];
